import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { EnumKeysPipe } from './pipes/enum-keys.pipe';
import { FormErrorStateMatcher } from '../core/form-error-state-matcher';
import { EnumKeyValueListPipe } from './pipes/enum-key-value.pipe';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaskDirective } from './directives/mask.directive';
import { PhonePipe } from './pipes/phone.pipe';
import { FormatNamePipe } from './pipes/uppercase.pipe';
import { AccessControlDirective } from './directives/access-control.directive';
import { YesNoPipe } from './pipes/yesNo.pipe';
import { ApprovalStatusPipe } from './pipes/approval-status.pipe';
import { FormatTitlePipe } from './pipes/format-title.pipe';
import { TimerIndexPipe } from './pipes/timer-index.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EnumKeysSortPipe } from './pipes/enum-keys-sort.pipe';
//import { NgxCurrencyDirective } from 'ngx-currency';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
   // NgxCurrencyDirective,
    NgxMaskDirective,
    NgxMaskPipe,
    DatePipe
  ],
  declarations: [
    EnumKeysPipe,
    EnumKeyValueListPipe,
    MaskDirective,
    PhonePipe,
    FormatNamePipe,
    ApprovalStatusPipe,
    AccessControlDirective,
    YesNoPipe,
    FormatTitlePipe,
    TimerIndexPipe,
    EnumKeysSortPipe,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    EnumKeysPipe,
    EnumKeyValueListPipe,
    FormsModule,
    ReactiveFormsModule,
    MaskDirective,
    PhonePipe,
    FormatNamePipe,
    ApprovalStatusPipe,
    AccessControlDirective,
    YesNoPipe,
    FormatTitlePipe,
    TimerIndexPipe,
    NgxMaskDirective,
    NgxMaskPipe,
    EnumKeysSortPipe,
    DatePipe
    //NgxCurrencyDirective,
  ],
  providers: [FormErrorStateMatcher, provideNgxMask()],
})
export class SharedModule {}
